<div
  [ngClass]="backgroundImageUrl ? '' : 'bg-gray-100 dark:bg-gray-950'"
  [ngStyle]="
    backgroundImageUrl
      ? {
          'background-image': 'url(' + backgroundImageUrl + ')',
          'background-size': 'cover',
          'background-position': 'center',
        }
      : {}
  "
  class="relative flex min-h-screen flex-col justify-center overflow-hidden px-4 py-8 sm:px-6 lg:px-8"
>
  <div
    [ngClass]="
      backgroundImageUrl
        ? 'absolute inset-0 ' + overlayClass
        : 'absolute inset-0 bg-gradient-to-br from-gray-100 via-gray-100 to-gray-200/70 dark:from-gray-950 dark:via-gray-950 dark:to-gray-900'
    "
  ></div>

  <div
    class="relative mx-auto w-full max-w-[520px] overflow-hidden rounded-2xl border border-gray-200 bg-white/95 shadow-xl backdrop-blur-sm dark:border-gray-700 dark:bg-gray-900/95"
  >
    <div
      class="border-b border-gray-200 px-6 py-6 dark:border-gray-700 sm:px-8 rounded-t-2xl"
      [ngClass]="headerClass"
    >
      <div class="flex items-center justify-center">
        @switch (logo.type) {
          @case ('image') {
            <img [alt]="logo.alt" [class]="logo.class || 'mx-auto h-20 w-auto'" [src]="logo.src" />
          }
          @case ('svg') {
            <div
              [class]="logo.class || 'mx-auto h-9 w-auto text-primary-600 dark:text-primary-400'"
              [innerHTML]="sanitizedSvgContent"
            ></div>
          }
          @default {
            <div
              class="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-600 dark:bg-primary-900/25 dark:text-primary-300"
            >
              <svg
                class="size-6"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0 1 12 12.75Zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 0 1-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 0 0 2.248-2.354M12 12.75a2.25 2.25 0 0 1-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 0 0-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 0 1 .4-2.253M12 8.25a2.25 2.25 0 0 0-2.248 2.146M12 8.25a2.25 2.25 0 0 1 2.248 2.146M8.683 5a6.032 6.032 0 0 1-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0 1 15.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 0 0-.575-1.752M4.921 6a24.048 24.048 0 0 0-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 0 1-5.223 1.082"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          }
        }
      </div>
      <div class="mt-4">
        <ng-content select="[title]" />
      </div>
    </div>

    <div class="px-6 py-6 sm:px-8 sm:py-8">
      <ng-content select="[content]" />
    </div>
  </div>
</div>
